import { render, staticRenderFns } from "./UserTotal.vue?vue&type=template&id=2dc211fc&scoped=true&"
import script from "./UserTotal.vue?vue&type=script&lang=js&"
export * from "./UserTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc211fc",
  null
  
)

export default component.exports